import { Box, Text, VStack, chakra } from '@chakra-ui/react';
import { BasePopover } from '@invara-dev/react-base';

type Props = {
  /** Company CRM description (Comment). */
  comment?: string | null;
  /** Company CRM Example field (for MainDB edit activity). */
  example?: string | null;
};

function trimmed(value: string | null | undefined): string {
  return String(value ?? '').trim();
}

/** Clickable "Details" link opening a popover with CRM description and Example field. */
export function ReportingRequirementDetailsLink({ comment, example }: Props) {
  const desc = trimmed(comment);
  const ex = trimmed(example);
  if (!desc && !ex) {
    return null;
  }

  return (
    <BasePopover
      contentProps={{ maxW: 'min(400px, 90vw)' }}
      trigger={
        <chakra.button
          type='button'
          fontSize='xs'
          color='secondary.500'
          fontWeight='medium'
          cursor='pointer'
          bg='transparent'
          border='none'
          p={0}
          m={0}
          lineHeight='inherit'
          textAlign='inherit'
          fontFamily='inherit'
          textDecoration='underline'
          _hover={{ color: 'secondary.600' }}
          aria-label='Open reporting requirement details from company CRM'>
          Details
        </chakra.button>
      }>
      <VStack align='stretch' gap={3}>
        {desc && (
          <Box>
            <Text fontWeight='semibold' fontSize='xs' mb={1}>
              Description
            </Text>
            <Text fontSize='xs' whiteSpace='pre-wrap' wordBreak='break-word' color='fg.muted'>
              {desc}
            </Text>
          </Box>
        )}
        {ex && (
          <Box>
            <Text fontWeight='semibold' fontSize='xs' mb={1}>
              Example
            </Text>
            <Text fontSize='xs' whiteSpace='pre-wrap' wordBreak='break-word' color='fg.muted'>
              {ex}
            </Text>
          </Box>
        )}
      </VStack>
    </BasePopover>
  );
}
